// activityEssenceReward
export default {
  routerTitle: '【盈宝证券】百万奖金激励创作者计划',

  cardOneModuleTitle: '每月瓜分奖金池',
  cardOneContentTitle: '精华内容奖励',
  cardOneAwardTitle: '每月奖金池总额',

  cardTwoModuleTitle: '季度排行榜奖励',

  cardThreeModuleTitle: '活动时间',
  activityTime: '2023年5月1日开始',
  cardThreeSubTitle: '内容要求',
  cardThreeSubDesc1: '创作者发布财报解读、文章、评论符合评选标准，可以被评选为精华，评选标准：',
  cardThreeSubDesc2: '创作者的内容被评为精华内容，可以获得精华积分，规则如下：',
  cardThreeTable1Header1: '内容类别',
  cardThreeTable1Header2: '内容评选标准',
  cardThreeTable1Row11: '精华财报解读',
  cardThreeTable1Row12:
    '1、结合港美个股最新发布的财报数据，进行深度的财报解读分析；<br/>2、文章有价值投资或短线交易结论观点；<br/>3、原创内容，内容客观、逻辑清晰，图文并茂，时效性强；<br/>4、财报发布后超过24小时或解读内容不够深度则评选为精华文章类型；<br/>5、单个创作者每天发文多篇，则根据文章数量及内容质量择优评审。',
  cardThreeTable1Row21: '精华文章',
  cardThreeTable1Row22:
    '1、主题与港美股市场、新股、窝轮牛熊、港美ETF相关；<br/>2、原创内容，内容客观，逻辑清晰，内容具备一定时效性；<br/>3、文章有价值投资或短线交易结论观点则获得精华概率更高；<br/>4、单个创作者每天发文多篇，则根据文章数量及内容质量择优评审。',
  cardThreeTable1Row31: '精华话题',
  cardThreeTable1Row32:
    '1.有热点时效，有讨论价值性；<br/>2.作为话题主持人能维护话题氛围，话题的内容和评论数量多，质量高。',
  cardThreeTable1Row41: '精华评论',
  cardThreeTable1Row42: '1、原创评论内容，与文章内容匹配度高，有个人观点；<br/>2、精华评论为抽选方式，单个用户每天最多获得不超过3条精华。',
  cardThreeTable1Tips: '注：用户多次积极发表原创文章、原创评论，虽未达精华标准，但内容具有参考价值观点，将会根据发表数量及质量选取文章或评论给与精华文章或精华评论奖励作为鼓励。',

  cardThreeTable2Header1: '内容类别',
  cardThreeTable2Header2: '积分奖励',
  cardThreeTable2Row1: '精华财报解读/篇',
  cardThreeTable2Row2: '精华文章/篇',
  cardThreeTable2Row3: '精华话题/个',
  cardThreeTable2Row4: '精华评论/条',

  cardFourModuleTitle: '活动奖励',
  cardFourSubTitle1: '1、精华内容奖励',
  cardFourSubDesc1:
    '（1）每月奖池80000港元<br />（2）创作者奖励=月奖池金额/社区当月总精华积分*创作者个人当月精华积分<br />（3）举例：当月社区所有创作者累积获得精华积分为2000，创作者A个人当月获得精华积分为50，那么该创作者收益=80000港元/2000*50=2000港元',
  cardFourSubTitle2: '2、排行榜奖励',
  cardFourSubDesc2: '季度排行榜奖励，按创作者当季度累积获得的精华总积分排名',
  cardFourModuleTips: '注：用户可在【我的-社区收益】了解个人精华内容奖励情况及申请奖金提现',
  cardFourTableHeader1: '季度名次',
  cardFourTableHeader2: '奖励金额',

  cardFiveModuleTitle: '常见问题',
  cardFiveModuleQ1: '社区L0等级用户没有发文权限,如何获得发文权限及参与活动?',
  cardFiveModuleA1:
    'L0用户可参与精华评论的评选奖励，其余奖励项目须升级为L1等级获得发文权限后才可参与,用户通过在社区阅读、评论、收藏、分享文章等方式获得积分进行升级，具体规则可在【我的-社区权益】了解。',
  cardFiveModuleQ2: '其他平台财经自媒体创作者,是否可申请加入参与?',
  cardFiveModuleA2:
    '财经自媒体创作者可提供自媒体账户及文章链接等方式向社区运营专员申请开通发文权限直接参与活动，盈宝社区专员微信号:<a href="javascript:;" class="copy-link-txt" data-clipboard-action="copy" data-clipboard-text="winbull8">winbull8</a>',
  cardFiveModuleQ3: '社区积分收益奖励与本精华内容奖励有什么不同?两个奖励可同时享受吗?',
  cardFiveModuleA3:
    '1)社区积分收益是所有盈宝用户每天在社区发文、点赞、评论等互动都会获得积分，系统每天统计用户积分贡献比例并派发奖金，用户可在【我的-社区收益】查询及提现。<br/>2)用户发布的文章或评论达到精华内容标准要求则可获得精华积分，系统每月1号按奖励规则统计及派发奖金，用户可在【我的-社区收益】查询及提现。<br/>3)用户可同时获得积分收益奖励及精华内容奖励，两者可同享。',
  cardFiveModuleQ4: '排行榜奖励什么时间派发?',
  cardFiveModuleA4:
    '每个季度的第1天将会统计上个季度的精华排行榜名单并派发排行榜奖金，用户可在【我的-社区收益】查看奖金并申请提现。',
  cardFiveModuleQ5: '除了在APP发布文章,是否支持在电脑发布文章?',
  cardFiveModuleA5:
    '社区L1等级用户可以通过网址<a href="javascript:;" class="copy-link-txt" data-clipboard-action="copy" data-clipboard-text="https://admin.winbull8.com/h5/analyst/index.html">https://admin.winbull8.com/h5/analyst/index.html</a>登陆个人盈宝账号发布文章。',
  cardFiveModuleQ6: '季度排行榜在什么情况下，排名20以内没有奖励?',
  cardFiveModuleA6:
    '如季度排行榜前20名出现有积分排名相同的情况，那么即使在排行榜显示排名20以内的用户，实际可能是20名以外。比如：你的精华积分是50分，榜单排名是第19名，但前面51分有3个用户，榜单排名都是第18名，实际上他们是第18、19和20名，所以你是第21名，因此无法获得排行榜奖励。',
  cardFiveModuleQ7: '季度排行榜奖励金额在什么情况下可能和规则不一样?',
  cardFiveModuleA7:
    '如季度排行榜出现积分排名相同的用户，则需要均摊奖金，这种情况下相同排名的用户奖金可能与规则不一致。比如：你和另外两名用户的积分都为50分，榜单排名同是第9名，但实际上三人是第9、10和11名，名次的奖金分别为500、500和200港元，但由于你们的积分一样，为了公平，每人获得的奖励数是400港元，计算公式为（500+500+200）/3=400。'
}
